import { faEdit, faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import Filter from "./desktop/filter"
import Resort from './desktop/resort'
import InfoIcon from "../../../InfoIcon"
import useFavorite from '../../../../hook/useFavorite'

export default function DesktopComponent() {


    const [desktopItems, setDesktopItems] = useState()


    let filteredproducts = useSelector((state) => state.product.filteredProducts)

    let dispatch = useDispatch()



    let stateproducts = useSelector(state => state.product.products)


    useEffect(() => {

        let items = []
        let products = filteredproducts ?? stateproducts

        if (products && Object.keys(products).length > 0) {

            products.forEach((product) => {

                items.push(<DesktopItem key={product.id} product={product} />)

            })
        }
        setDesktopItems(items)



    }, [filteredproducts, stateproducts])


    if (!desktopItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            <div className="grid-container-4-col" >
                {desktopItems}
            </div>


        </Filter>
        <Backdrop />

    </Fragment>
}


function DesktopItem(props) {
    const { product } = props
 
    const { addFavorite, removeFavorite, icon, selected } = useFavorite(product.id)

    return <div className="card">
        <img className="card-img-top" src={product.image} alt={product.title} style={{ width: '100%', height: '100%' }} />
        <div className="card-body">
            <h5 className="card-title">{product.title} <InfoIcon icon={icon} onClick={() => {
                if (selected) {
                    removeFavorite()
                    return
                }
                addFavorite()

            }} style={{cursor:'pointer'}} /></h5>
            <div className="card-text">
                <p>{product.ptype}</p>
                <p>{product.description}</p>
            </div>
            <Link className="btn btn-outline-secondary bgnt" style={{ width: '100%' }} to={`/products/${product.id}`} ><InfoIcon icon={faInfoCircle} title='product details, order' />Details/Order</Link>

        </div>
    </div>


}